import React, { Component } from 'react';
import '../assets/custom.css';
import Header from "../HomeHeaderComponent/HomeHeader";
import Helpers from "../Shared/Helpers";
import REST from "../Shared/REST";
import TRACKING from "../Shared/DataTrackingPoints";
import {Modal} from "react-bootstrap";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";
import HeaderComponent from '../Shared/Header';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {selectClass, updateStudent, updateTeacher, userLogout} from "../TeachersComponent/actions";

var logoDocs = require('../assets/images/ico_docs.png');
var logoVideo = require('../assets/images/ico_video.png');

class ResourcesLinkComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                analytics: {
                    type: TRACKING.RESOURCES_DOWNLOAD,
                    metadata: {resourceId: this.props.value},
                }
            },
            ()=> this.handleAnalytics());
    }

    render(){
        let sameTab = this.props.sameTab;
        let target;
        if (sameTab){
            target="";
        }else{
            target="_blank";
        }
        return (
        <li>{this.props.download==="No"?<a onClick={this.handleClick}
               href={this.props.url} target={target} >{this.props.title}</a>:
            <a onClick={this.handleClick}
               href={this.props.url} target={target} download>{this.props.title}</a>}</li>
        )
    }
}

class VideoTutorialComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analytics: {
                type: null,
                metadata: null,
            }};
        this.handleClick = this.handleClick.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleClick(){
        this.setState({
                analytics: {
                    type: TRACKING.VIDEO_PLAY,
                    metadata: {videoId: this.props.id},
                }
            },
            ()=> this.handleAnalytics());
        this.props.handleOpenVideo(this.props.id, this.props.title, this.props.url);
    }

    render(){
        return (
            <li><a onClick={this.handleClick}>{this.props.title}</a></li>
        )
    }
}

class ResourcesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        };
        this.handleOpenVideo=this.handleOpenVideo.bind(this);
        this.handleCloseVideo=this.handleCloseVideo.bind(this);
    }

    async componentDidMount() {
        Helpers.authorize(this);
    }

    handleOpenVideo(id, title, url){
        this.setState({
            showVideo:true,
            videoURL:url,
            videoId: id,
            videoTitle:title
        })
    }

    handleLogout = () => {
        REST.logout().then(async (response) => {
            if (response.success) {
                this.props.callback({});
                await this.props.persistor.purge();
                await this.props.userLogout();
                this.props.history.push("/");
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    };

    handleCloseVideo(){
        this.setState({
            showVideo:false,
            videoURL:null,
            videoId: null,
            videoTitle:null
        })
    }

    render(){
        return (
            <div>
                <HeaderComponent logout={this.handleLogout} notifications bugReport resources studentClick={this.handleStudentClick}/>


                <div className="clearfix"></div>

                <div className="section bgGreen">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>Resources page is coming...</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <div className="row">

                        </div>
                    </div>
                </div>
                <Modal id={"videoBox"} show={this.state.showVideo} style={{top:100, left:-270}}>
                    <div className="modal-content" style={{width:620}}>
                        <div className="modal-header" style={{width:620}}>
                            <h4>{this.state.videoTitle}</h4>
                        </div>
                        <div className={"modal-body"}>
                            <iframe width="560" height="315" src={this.state.videoURL}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen></iframe>
                        </div>
                        <div className="modal-footer">
                            <div style={{width: 100, marginLeft:'auto',marginRight:'auto'}}>
                                <a className="handBtn" onClick={this.handleCloseVideo} >
                                    <span>Close</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
                <footer>
                    <div className="container">
                        <div className="col-lg-12">
                            <hr/>
                            <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the North Carolina State University and Penn State University. </p>
                        </div>
                    </div>
                </footer>

            </div >
        )
    }
}

const bindActionToProps = dispatch => {
    return {
        selectClass: async(selectedClass) => await dispatch(selectClass(selectedClass)),
        updateStudent: async(selectedStudent) => await dispatch(updateStudent(selectedStudent)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher
});



export default connect(mapStateToProps,bindActionToProps)(withRouter(ResourcesComponent));